import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

import Lists from '@/components/Lists'
import List from '@/components/List'
import CreateList from '@/components/CreateList'
import EditList from '@/components/EditList'
import User from '@/components/User'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/u/:username',
      name: 'UserView',
      props: true,
      component: User
    },
    {
      path: '/lists',
      name: 'ListIndex',
      component: Lists
    },
    {
      path: '/lists/new',
      name: 'ListCreate',
      component: CreateList
    },
    {
      path: '/lists/:id',
      name: 'ListView',
      component: List
    },
    {
      path: '/lists/:id/edit',
      name: 'ListEdit',
      component: EditList
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js